import classNames from 'classnames';
import {
  AddressBlock,
  MapRender,
  FlexContainer,
  TitledBlock,
} from 'components';
import { Marker } from 'react-leaflet';
import styles from './PropertyArea.module.scss';

/*
*
*
country: "England"
district: "Islington"
lat: "51.5245434"
line1: "43"
line2: "24 Leonard Street"
long: "-0.0861554"
name: "43, 24 Leonard St"
postcode: "EC2A 4BY"
street: "Leonard Street"
town: "LONDON"
* */

/**
 * PropertyArea
 *
 * @return {JSX.Element}
 */
const PropertyArea = ({ className, property }) => {
  const {
    data: { address },
  } = property;

  const latLng = {
    lat: address?.lat,
    lng: address?.long,
  };

  return (
    <FlexContainer
      className={classNames(
        styles.PropertyArea,
        className,
        PropertyArea.displayName
      )}
      column
    >
      <TitledBlock title="Address">
        <AddressBlock address={address} />
      </TitledBlock>
      <MapRender center={latLng} zoom={14}>
        <Marker position={latLng} />
      </MapRender>
    </FlexContainer>
  );
};

PropertyArea.displayName = 'PropertyArea';

export default PropertyArea;
